import React, { useContext, useEffect, useState } from "react";
import { StarOutlined } from "@ant-design/icons";
import { Tabs } from "antd";

import Layout from "../layout/Layout";
import LeadReport from "../components/dashboard/LeadReport";
import MarketingReport from "../components/dashboard/MarketingReport";
import ActivitiesReport from "../components/dashboard/ActivitiesReport";
import MyViewReport from "../components/dashboard/MyViewReport";
import RecommendedReport from "../components/dashboard/RecommendedReport";
import ReviewDashboard from "../components/reputation-manager/ReviewDashboard";
import { AuthContext } from "../context/AuthContext";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../components/loader";
import { getAccountInfo } from "../actionCreator/commonActionCreator";
import { getToken } from "../utils/auth";
import { getPlatformReviews } from "../actionCreator/reputationManagerActionCreator";

const MyDashboard = () => {
  const dispatch = useDispatch();
  const [permissions, setPermissions] = useState();
  const [filteredItems, setFilteredItems] = useState([]);
  const { isAuthenticated } = useContext(AuthContext);

  const loading = useSelector((state) => state.CommonReducer.loading);

  const items = [
    {
      key: "1",
      modules: ["Leads"],
      label: (
        <span className="d-flex align-items-center">
          <i className="fa tab-img las la-users"></i>Leads
        </span>
      ),
      children: (
        <div>
          <LeadReport />
        </div>
      ),
    },
    {
      key: "2",
      modules: ["Leads"],
      label: (
        <span className="d-flex align-items-center">
          <i className="fa tab-img las la-bullhorn text-info"></i>Marketing
        </span>
      ),
      children: (
        <div>
          <MarketingReport />
        </div>
      ),
    },
    {
      key: "3",
      modules: ["Leads"],
      label: (
        <span className="d-flex align-items-center">
          <i className="fa tab-img las la-clock"></i>Activities
        </span>
      ),
      children: (
        <div>
          <ActivitiesReport />
        </div>
      ),
    },
    {
      key: "4",
      modules: ["Company", "Executive"],
      label: (
        <span className="d-flex align-items-center">
          <i className="fa tab-img las la-eye"></i>My View
        </span>
      ),
      children: (
        <div>
          <MyViewReport />
        </div>
      ),
    },
    {
      key: "5",
      modules: ["Company", "Executive"],
      label: (
        <span className="d-flex align-items-center">
          <i className="fa tab-img las la-hand-point-up"></i>Smart
          Recommendation
        </span>
      ),
      children: (
        <div>
          <RecommendedReport />
        </div>
      ),
    },
    {
      key: "6",
      modules: ["Reputation Manager"],
      label: (
        <span className="d-flex align-items-center gap-10">
          <StarOutlined className="text-theme" />
          Reputation Manager
        </span>
      ),
      children: <ReviewDashboard />,
    },
  ];

  useEffect(() => {
    if (isAuthenticated && permissions && typeof permissions === "object") {
      const viewOnlyModules = Object.entries(permissions)
        .filter(([_, permissions]) =>
          permissions?.find((d) => d?.name === "View")
        )
        .map(([moduleName]) => moduleName);
      setFilteredItems(
        items?.filter((d) =>
          d?.modules.some((item) => viewOnlyModules.includes(item))
        )
      );
    }
  }, [permissions, isAuthenticated]);

  useEffect(() => {
    const getData = async () => {
      if (isAuthenticated) {
        const res = await dispatch(getAccountInfo(getToken()));
        setPermissions(res?.permissions);
        dispatch(
          getPlatformReviews({
            page: 0,
            size: 3,
          })
        );
      }
    };
    getData();
  }, [dispatch, isAuthenticated]);

  return (
    <Layout>
      <div id="tabscompany">
        <h3 className="pagetitle">Dashboard</h3>
        {loading ? <Loader /> : <Tabs items={filteredItems} type="card" />}
      </div>
    </Layout>
  );
};

export default MyDashboard;
